import http from '@/utils/http'
import { logError } from '@/utils/logger'

const initialState = () => ({
  item: {}
})

export const state = initialState()

export const mutations = {
  RESET (state) {
    const newState = initialState()
    Object.keys(newState).forEach(key => {
      state[key] = newState[key]
    })
  },
  SET_ITEM (state, item) {
    state.item = item
  }
}

export const getters = {
  item: state => state.item
}

export const actions = {
  fetchDocumentAttachmentById ({ rootGetters, commit }, attachmentId) {
    return http({
      url: `${process.env.VUE_APP_API_URL}documentattachment/${rootGetters['auth/token']}/${attachmentId}`
    }).then((data = {}) => {
      commit('SET_ITEM', data)
      return data
    }).catch(e => {
      commit('RESET')
      logError(e, { attachmentId }, 'jobDocumentAttachment: error fetching attachment')
      return null
    })
  },
  saveDocumentAttachment ({ rootGetters, commit }, { jobId, file }) {
    const data = {
      FileName: file.name,
      Extension: file.extension.toLowerCase(),
      BinaryDataBase64: file.base64,
      JobID: jobId
    }

    return http({
      method: 'post',
      url: `${process.env.VUE_APP_API_URL}documentattachment/save/${rootGetters['auth/token']}`,
      data
    }).then(id => {
      data.ID = id
      commit('SET_ITEM', data)

      return data
    }).catch(e => {
      logError(e, { jobId, file }, 'jobDocumentAttachment: error saving attachment')
      return {}
    })
  },
  deleteDocumentAttachmentById ({ rootGetters, commit }, attachmentId) {
    return http({
      url: `${process.env.VUE_APP_API_URL}documentattachment/delete/${rootGetters['auth/token']}/${attachmentId}`
    }).then(data => {
      commit('RESET')
      return data
    }).catch(e => {
      logError(e, { attachmentId }, 'jobDocumentAttachment: error deleting attachment')
      return false
    })
  }
}
